(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyDialogController', DinghyDialogController);

    DinghyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dinghy'];

    function DinghyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dinghy) {
        var vm = this;

        vm.dinghy = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dinghy.id !== null) {
                Dinghy.update(vm.dinghy, onSaveSuccess, onSaveError);
            } else {
                Dinghy.save(vm.dinghy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateDeactivated = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
